/* pawever-quiz.js — upload to Shopify Assets */
(function () {
  'use strict';

  const CI   = 'https://cdn.shopify.com/s/files/1/0645/5374/6613/files/Pawever_Icons_2.svg?v=1776069753';
  const TOTAL = 15;
  const INFO_SLIDES  = [3, 5, 8, 10, 11, 13, 14];
  const MULTI_SLIDES = [2, 7];

  /* ── SVG helpers ── */
  const chk = `<svg width="10" height="10" viewBox="0 0 12 12" fill="none"><polyline points="2,6 5,9 10,3" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
  const verifySVG = `<svg width="16" height="16" viewBox="0 0 20 20" style="flex-shrink:0"><circle cx="10" cy="10" r="10" fill="#349559"/><polyline points="5,10 8.5,13.5 15,7" stroke="white" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
  const flameSVG  = `<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M12 2C12 2 8 7 8 11C8 13.21 9.79 15 12 15C14.21 15 16 13.21 16 11C16 9.5 15.2 8.1 14 7.2C14 7.2 14.5 10 12 10C12 10 10 8.5 12 2Z" stroke="white" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 15C10.34 15 9 16.34 9 18C9 19.66 10.34 21 12 21C13.66 21 15 19.66 15 18C15 16.34 13.66 15 12 15Z" stroke="white" stroke-width="1.6" stroke-linecap="round"/></svg>`;
  const dropSVG   = `<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M12 3L5 12C5 15.87 8.13 19 12 19C15.87 19 19 15.87 19 12L12 3Z" stroke="white" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/><path d="M9 14C9 15.66 10.34 17 12 17" stroke="white" stroke-width="1.6" stroke-linecap="round"/></svg>`;
  const layerSVG  = `<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M12 3L3 8L12 13L21 8L12 3Z" stroke="white" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/><path d="M3 13L12 18L21 13" stroke="white" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/><path d="M3 18L12 22.5L21 18" stroke="white" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" opacity="0.55"/></svg>`;

  function r()  { return `<span class="radio"><img class="ci" src="${CI}" alt=""></span>`; }
  function cb() { return `<span class="checkbox"><img class="ci" src="${CI}" alt=""></span>`; }
  function ac() { return `<div class="pq-acc-check">${chk}</div>`; }
  function ti() { return `<span class="t-icon"><img src="${CI}" alt=""></span>`; }

  function so(n, t)  { return `<button class="pq-opt" onclick="PQ.single(this,${n})">${r()}${t}</button>`; }
  function mo(t)     { return `<button class="pq-opt multi" onclick="PQ.multi(this)">${cb()}${t}</button>`; }
  function ai(title, body) {
    return `<div class="pq-acc"><div class="pq-acc-header" onclick="PQ.acc(this)"><div class="pq-acc-left">${ac()}${title}</div><span class="pq-acc-arrow">▼</span></div><div class="pq-acc-body">${body}</div></div>`;
  }
  function ph(label, title, sub) {
    return `<div class="pq-phase"><div class="pq-phase-left"><div class="pq-phase-dot"></div><div class="pq-phase-line"></div></div><div class="pq-phase-content"><div class="pq-phase-label">${label}</div><div class="pq-phase-title" style="color:#349559">${title}</div><div class="pq-phase-sub" style="color:#1F3F33">${sub}</div></div></div>`;
  }
  function btn(n, back) {
    return `<button class="pq-btn" onclick="PQ.next(${n})">Continue</button>${back ? `<button class="pq-back" onclick="PQ.prev(${n})">← Back</button>` : ''}`;
  }

  /* ── Slide definitions 1–14 ── */
  const slides = [

    /* 1 */
    `<div class="pq-body">
      <h2>How would you describe your cat's <em>energy levels</em> lately?</h2>
      <p class="pq-sub">Select the option that best applies.</p>
      <div class="pq-options" id="opts-1">
        ${so(1,'Full of energy — always active and playful')}
        ${so(1,'Slightly less playful than they used to be')}
        ${so(1,'Noticeably slower — sleeps a lot more')}
        ${so(1,'Very low energy — barely interested in play')}
      </div>
      <button class="pq-btn" onclick="PQ.next(1)">Continue</button>
    </div>`,

    /* 2 */
    `<div class="pq-body">
      <h2>Have you noticed any of these signs in your cat?</h2>
      <p class="pq-sub">Select all that apply.</p>
      <div class="pq-options" id="opts-2">
        ${mo('Hesitation before jumping up on furniture')}
        ${mo('Stiffness after waking up or resting')}
        ${mo('Moving more slowly than usual')}
        ${mo('Less grooming or reaching certain spots')}
        ${mo('None of these yet')}
      </div>
      ${btn(2,true)}
    </div>`,

    /* 3 */
    `<div class="pq-body">
      <h2>These are all signs of joint degeneration. And it's <em>more common than you'd think.</em></h2>
      <p class="pq-sub">Cats are experts at hiding pain. Most owners don't even notice until it's advanced to full-blown limping.</p>
      <div class="pq-stat-stack">
        <div class="pq-stat"><div class="num">60<span>%</span></div><div class="desc">of cats over age 6 show signs of joint degeneration</div></div>
        <div class="pq-stat"><div class="num">90<span>%</span></div><div class="desc">of cats over 12 are affected — even if they appear completely normal</div></div>
      </div>
      ${btn(3,true)}
    </div>`,

    /* 4 */
    `<div class="pq-body">
      <h2>Does your cat currently take a <em>joint supplement?</em></h2>
      <div class="pq-options" id="opts-4">
        ${so(4,'Yes — one or more supplements daily')}
        ${so(4,'Occasionally, but not consistently')}
        ${so(4,"No — I haven't found the right one")}
        ${so(4,"No — I wasn't sure it was necessary")}
      </div>
      ${btn(4,true)}
    </div>`,

    /* 5 */
    `<div class="pq-body">
      <h2>Most joint supplements only target inflammation. <em>Pawever Plus™ goes deeper.</em></h2>
      <div class="pq-pillars">
        <div class="pq-pillar"><div class="pq-pillar-icon">${flameSVG}</div><div><h4>Fights Inflammation</h4><p>Green Lipped Mussel and Glucosamine work together to calm chronic low-grade joint inflammation — the hidden driver of stiffness and discomfort in ageing cats.</p></div></div>
        <div class="pq-pillar"><div class="pq-pillar-icon">${dropSVG}</div><div><h4>Lubricates Joints</h4><p>Hyaluronic Acid restores the synovial fluid that cushions your cat's joints — reducing friction and making movement smooth and comfortable again.</p></div></div>
        <div class="pq-pillar"><div class="pq-pillar-icon">${layerSVG}</div><div><h4>Rebuilds Cartilage</h4><p>Collagen Type II and Glucosamine support structural repair of worn cartilage — so your cat's joints aren't just soothed, they're actually rebuilding.</p></div></div>
      </div>
      ${btn(5,true)}
    </div>`,

    /* 6 */
    `<div class="pq-body">
      <h2>How old is your <em>cat?</em></h2>
      <div class="pq-options" id="opts-6">
        ${so(6,'Under 3 years (kitten / young adult)')}
        ${so(6,'3–6 years (adult)')}
        ${so(6,'7–10 years (mature)')}
        ${so(6,'11+ years (senior)')}
      </div>
      ${btn(6,true)}
    </div>`,

    /* 7 */
    `<div class="pq-body">
      <h2>Besides energy and joints, what else concerns you about <em>your cat's health?</em></h2>
      <p class="pq-sub">Select all that apply.</p>
      <div class="pq-options" id="opts-7">
        ${mo('Longevity &amp; ageing')}
        ${mo('Heart health')}
        ${mo('Cognitive function')}
        ${mo('Coat &amp; skin health')}
        ${mo('Weight &amp; muscle maintenance')}
      </div>
      ${btn(7,true)}
    </div>`,

    /* 8 */
    `<div class="pq-body">
      <h2>Pawever Plus supports your cat's <em>whole body</em> — not just their joints.</h2>
      <p class="pq-sub">With 11 clinically studied ingredients selected specifically for ageing cats.</p>
      <img src="https://cdn.shopify.com/s/files/1/0645/5374/6613/files/Pawever-Plus-For-Cats-In-Snow.png?v=1776078588" class="pq-section-img" alt="Pawever Plus">
      <div class="pq-accordion">
        ${ai('Joints &amp; Arthritis','Helps regulate inflammation and support healthy cartilage, so your cat can keep moving with confidence — even as they age.')}
        ${ai('Energy Levels',"NMN directly raises NAD⁺ — the molecule that powers every cell in your cat's body. Combined with L-Carnitine, which shuttles fatty acids into the mitochondria for fuel, the result is a noticeable lift in daily energy and willingness to move.")}
        ${ai('Cognitive Function',"Helps support brain function and mental clarity, promoting awareness, engagement, and normal daily behaviours in senior cats — so they stay curious and connected, not withdrawn.")}
        ${ai('Heart, Immune &amp; Vision',"Taurine is an essential amino acid cats can't produce in sufficient quantities — critical for cardiac muscle function, sharp vision, and immune defence. CoQ10 supports mitochondrial energy in the heart, while NMN and L-Carnitine further back cardiovascular endurance.")}
        ${ai('Longevity','NMN raises NAD⁺ levels that naturally decline with age — restoring the cellular signalling that drives DNA repair, metabolism, and healthy ageing. Supporting NAD⁺ is one of the most evidence-backed approaches to extending healthspan in mammals.')}
        ${ai('Essential Nutrient Support','Delivers essential amino acids and micronutrients — including Taurine and Manganese — that are commonly deficient in ageing cats. These foundational nutrients underpin everything from muscle tone to enzyme function and whole-body resilience.')}
      </div>
      ${btn(8,true)}
    </div>`,

    /* 9 */
    `<div class="pq-body">
      <h2>When choosing a supplement for your cat, how important is <em>third-party testing?</em></h2>
      <div class="pq-options" id="opts-9" style="margin-top:28px">
        ${so(9,'Very important — I only buy tested products')}
        ${so(9,'Somewhat important')}
        ${so(9,"Not something I've thought about")}
      </div>
      ${btn(9,true)}
    </div>`,

    /* 10 */
    `<div class="pq-body">
      <h2>Your cat deserves the same <em>quality standards</em> you'd demand for yourself.</h2>
      <p class="pq-sub">Australian pet supplements aren't held to the same testing standards as human products. At Pawever, we're raising the bar — every batch is made with human-grade ingredients and independently lab tested for purity and safety.</p>
      <img src="https://cdn.shopify.com/s/files/1/0645/5374/6613/files/Single_Capsule_Petri_Dish_Pawever.jpg?v=1776145907" class="pq-lab-img" alt="Lab testing">
      <p style="font-size:14px;font-weight:600;color:#1F3F33;margin-bottom:14px">We test for:</p>
      <div class="pq-test-list">
        <div class="pq-test-item">${ti()}Heavy metals (lead, arsenic, mercury, cadmium)</div>
        <div class="pq-test-item">${ti()}Ingredient purity &amp; potency</div>
      </div>
      ${btn(10,true)}
    </div>`,

    /* 11 */
    `<div class="pq-body">
      <h2>How Pawever Plus stacks up <em>against the rest.</em></h2>
      <div class="pq-table">
        <div class="thead"><div></div><div class="col-h">Pawever Plus</div><div class="col-h">Most Others</div></div>
        <div class="row"><div class="feat">11 clinically studied ingredients</div><div class="col"><span class="dot-yes"></span></div><div class="col"><span class="dot-no"></span></div></div>
        <div class="row"><div class="feat">Includes NMN &amp; CoQ10</div><div class="col"><span class="dot-yes"></span></div><div class="col"><span class="dot-no"></span></div></div>
        <div class="row"><div class="feat">Human grade quality ingredients</div><div class="col"><span class="dot-yes"></span></div><div class="col"><span class="dot-no"></span></div></div>
        <div class="row"><div class="feat">3rd-party tested for heavy metals &amp; purity</div><div class="col"><span class="dot-yes"></span></div><div class="col"><span class="dot-no"></span></div></div>
        <div class="row"><div class="feat">Easy sprinkle capsule format</div><div class="col"><span class="dot-yes"></span></div><div class="col"><span class="dot-no"></span></div></div>
        <div class="row"><div class="feat">60 day money-back guarantee</div><div class="col"><span class="dot-yes"></span></div><div class="col"><span class="dot-no"></span></div></div>
      </div>
      ${btn(11,true)}
    </div>`,

    /* 12 */
    `<div class="pq-body">
      <h2>When choosing a supplement, how important are <em>clinical studies</em> to you?</h2>
      <div class="pq-options" id="opts-12">
        ${so(12,'Very important')}
        ${so(12,'Somewhat important')}
        ${so(12,'Not important')}
        ${so(12,'Not sure')}
      </div>
      ${btn(12,true)}
    </div>`,

    /* 13 */
    `<div class="pq-body">
      <h2>Every ingredient in Pawever Plus is <em>clinically studied.</em></h2>
      <p class="pq-sub">Each of our 11 ingredients is backed by peer-reviewed research — and dosed at the therapeutic amounts used in those studies. We don't use token amounts to pad a label. We use the levels that actually work.</p>
      <div class="pq-proof-list">
        <div class="pq-proof"><h4>Backed by research</h4><p>Each ingredient is selected because the science supports it — not because it's cheap to include or trendy to mention on a label.</p></div>
        <div class="pq-proof"><h4>Meaningful amounts</h4><p>A supplement that contains 1mg of NMN isn't a longevity formula — it's marketing. We use dosages that reflect what the research actually shows to be effective.</p></div>
        <div class="pq-proof"><h4>Human-grade standards</h4><p>Manufactured in a facility held to the same rigour you'd expect from a supplement made for people.</p></div>
      </div>
      ${btn(13,true)}
    </div>`,

    /* 14 */
    `<div class="pq-body">
      <h2>What to expect when your cat starts <em>Pawever Plus.</em></h2>
      <p class="pq-sub">Results build over time — most owners notice a difference within 3–4 weeks.</p>
      <div class="pq-phases">
        ${ph('Weeks 1–3','The Comfort Phase — Initial Relief Begins','Green Lipped Mussel, Glucosamine, and Type II Collagen begin calming chronic low-grade joint inflammation. Many owners notice their cat moving more freely after naps, or showing more interest in their surroundings.')}
        ${ph('Weeks 4–6','The Rebuilding Phase — Cartilage &amp; Joint Support Deepens','With inflammation settling, key joint supporters continue restoring cartilage integrity and relubricating joints. Owners often notice their cat jumping more willingly, or returning to spots they\'d abandoned.')}
        ${ph('Weeks 5–7','The Energy Phase — Daily Energy &amp; Playfulness Return','NMN and CoQ10 are now meaningfully supporting NAD⁺ restoration and mitochondrial function. This is when many owners describe seeing their cat\'s personality come back — more curious, more playful, more engaged.')}
        ${ph('Weeks 9–12','The Maintenance Phase — Long-Term Protection &amp; Longevity','Pawever Plus becomes a true longevity tool. The formula continues protecting against further degeneration, sustaining the gains made in earlier phases — and supporting your cat\'s cellular health for the long run.')}
      </div>
      <div class="pq-review">
        <img src="https://pawever.com/cdn/shop/files/1758455082__img_1659__original_2_1.jpg?v=1768557378&width=800" class="pq-review-img" alt="Customer review">
        <div class="pq-stars">★★★★★</div>
        <div class="pq-review-text">"My 16 year old cat hadn't run in years. From around day 20 of using Pawever, I could see a change. She became more curious and even ran outside onto the deck."</div>
        <div class="pq-review-author">${verifySVG}Verified Customer — Ellen H.</div>
      </div>
      ${btn(14,true)}
    </div>`
  ];

  /* ── Controller ── */
  window.PQ = {
    current: 1,

    init() {
      const container = document.getElementById('pq-container');
      if (!container) return;
      this.render(1);
    },

    render(n) {
      const jsContainer  = document.getElementById('pq-container');
      const liqContainer = document.getElementById('pq-slide-15-wrap');
      const banner       = document.getElementById('pq-banner');

      if (n === 15) {
        jsContainer.style.display  = 'none';
        liqContainer.style.display = 'flex';
        if (banner) banner.classList.add('hidden');
      } else {
        jsContainer.style.display  = 'flex';
        liqContainer.style.display = 'none';
        if (banner) banner.classList.remove('hidden');
        jsContainer.innerHTML = `<div class="pq-slide active" id="pq-slide-${n}">${slides[n - 1]}</div>`;
      }

      document.getElementById('pq-step').textContent = `${n} / ${TOTAL}`;
      document.getElementById('pq-bar').style.width = ((n - 1) / (TOTAL - 1) * 100) + '%';
      window.scrollTo({ top: 0, behavior: 'smooth' });
      this.current = n;
    },

    next(n) {
      if (INFO_SLIDES.includes(n) || MULTI_SLIDES.includes(n)) {
        this.render(n + 1); return;
      }
      const sel = document.querySelector(`#pq-slide-${n} .pq-opt.selected`);
      if (!sel) {
        const opts = document.querySelector(`#pq-slide-${n} .pq-options`);
        if (opts) { opts.style.animation = 'none'; opts.offsetHeight; opts.style.animation = 'pqShake 0.35s ease'; }
        return;
      }
      this.render(n + 1);
    },

    prev(n)   { if (n > 1) this.render(n - 1); },
    goBack()  { this.render(14); },
    single(btn, n) {
      btn.closest('.pq-options').querySelectorAll('.pq-opt').forEach(b => b.classList.remove('selected'));
      btn.classList.add('selected');
    },
    multi(btn) { btn.classList.toggle('selected'); },
    acc(hdr)   { hdr.parentElement.classList.toggle('open'); }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => PQ.init());
  } else {
    PQ.init();
  }

})();
